import { type Actor, withEffects } from "../system";
import browseTier from "./browseTier";
import loadStatus from "./loadStatus";
import loadTiersConfiguration from "./loadTiersConfiguration";

import type { RewardCenterMsg, RewardCenterState } from "./types";

const openSupportChat = async (): Promise<RewardCenterMsg> => {
  await window.proto?.show();
  await window.proto?.open();
  return { type: "supportChatOpened" };
};

const rewardCenter: Actor<RewardCenterState, RewardCenterMsg> = {
  init: {
    tiers: [],
    faq: [],
    selectedFaq: null,
    progress: 0,
    currentTier: null,
    button: {
      hasClaimable: false, // Todo: Missing BE Supports
    },
    visibility: {
      isOpen: false,
    },
    head: {
      isExpanded: false,
    },
    history: {
      // TODO: This
    },
  },
  receive: (state, msg, meta) => {
    switch (msg.type) {
      case "toggleFaq":
        if (msg.id === state.selectedFaq) {
          return {
            ...state,
            selectedFaq: null,
          };
        } else {
          return {
            ...state,
            selectedFaq: msg.id,
          };
        }
      case "selectTab":
        if (msg.tab) {
          return {
            ...state,
            tab: msg.tab,
          };
        } else {
          return state;
        }
      case "browseTier":
        return browseTier(state, msg, meta);
      case "selectTier":
        return {
          ...state,
          selectedTier: msg.id,
        };
      case "statusLoaded": // Initial Load of the Status
        return loadStatus(state, msg, meta);
      case "tiersConfigurationLoaded":
        return loadTiersConfiguration(state, msg, meta);
      case "faqLoaded":
        return {
          ...state,
          faq: msg.faq,
        };
      case "toggleVisibility": // Opening of the Reward
        return {
          ...state,
          visibility: {
            ...state.visibility,
            isOpen: !state.visibility?.isOpen,
          },
        };
      case "toggleHead":
        return {
          ...state,
          head: {
            ...state.head,
            isExpanded: !state.head?.isExpanded,
          },
        };
      case "queryFailed":
        if (msg.query === "tierConfiguration") {
          return withEffects(state, {
            send: [
              "backend",
              {
                type: "loadTierConfiguration",
              },
            ],
          });
        }
        if (msg.query === "faq") {
          return withEffects(state, {
            send: [
              "backend",
              {
                type: "loadFaq",
              },
            ],
          });
        }
        if (msg.query === "status") {
          return { ...state, error: true };
        }
        return state;
      case "contactSupport":
        return withEffects(state, {
          task: [openSupportChat, "rewardCenter"],
        });
      default:
        return state;
    }
  },
};

export default rewardCenter;
export type { Action, RewardCenterMsg, RewardCenterState } from "./types";
